import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateFilter } from '../../../../../../../store/actions/filter.actions'
import InputDateUTC from '../../../../../../FormControl/input/InputDateUTC'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FilterButtonClasses = ({ disabled }) => {
  const open = useSelector((state) => state?.filter?.analyticsCurriculumHistory?.open || false)
  const form = useSelector((state) => state?.filter?.analyticsCurriculumHistory?.filter || {})
  const dispatch = useDispatch()

  const onChange = (key, value) => {
    dispatch(updateFilter('analyticsCurriculumHistory', { ...form, [key]: value }))
  }
  return (
    <>
      <FontAwesomeIcon icon='bars-filter' className='text-primary' size='xl' />
      <InputDateUTC
        id='generated-at-start-date'
        name='startDate'
        value={form?.startDate}
        maxDate={form?.endDate}
        placeholder={'Start Date'}
        onChange={(value) => onChange('startDate', value)}
        clearable={true}
      />
      <InputDateUTC
        id='generated-at-end-date'
        name='endDate'
        value={form?.endDate}
        minDate={form?.startDate}
        placeholder={'End Date'}
        isStartOfTheDay={false}
        onChange={(value) => onChange('endDate', value)}
        clearable={true}
      />
    </>
  )
}
export default FilterButtonClasses
